import { FaArrowsAlt, FaArrowRight, FaArrowLeft, FaArrowDown, FaArrowUp } from 'react-icons/fa'
import cn from 'classnames'
import type React from 'react'
import type { EdgeDirectionConstraint } from 'types/domain'

import 'components/graph/controls/controls.less'

const DIRECTION_INFO: Record<EdgeDirectionConstraint, { icon: React.ComponentType; label: string }> = {
  free: { icon: FaArrowsAlt, label: 'Free' },
  ltr: { icon: FaArrowRight, label: 'Left to right' },
  rtl: { icon: FaArrowLeft, label: 'Right to left' },
  ttb: { icon: FaArrowDown, label: 'Top to bottom' },
  btt: { icon: FaArrowUp, label: 'Bottom to top' },
}

type KindDirectionControlProps = {
  direction: EdgeDirectionConstraint
  onClick: () => void
}

const KindDirectionControl = ({ direction, onClick }: KindDirectionControlProps) => {
  const { icon: Icon, label } = DIRECTION_INFO[direction]
  const title = `Direction: ${label}`

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onClick()
  }

  return (
    <div className={cn('control', 'kind-direction')} data-graph-type="control" title={title}>
      <a className="icon" onClick={handleClick}>
        <Icon aria-hidden />
        <span className="sr-only">{title}</span>
      </a>
    </div>
  )
}

export default KindDirectionControl
